import { render, staticRenderFns } from "./DialogPopup.vue?vue&type=template&id=19994ef3&"
import script from "./DialogPopup.vue?vue&type=script&lang=js&"
export * from "./DialogPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports